// ops — четвёртый iPhone-виджет: «Отгрузка и расходы» (Scriptable).
// GET /api/ops/widget-money у weern-ops, тот же Bearer OPS_WIDGET_TOKEN.
//
// Две левые ячейки — «готово к отгрузке» РОВНО в том смысле, в каком это
// показывают кабинеты менеджеров (иначе виджет и экран расходятся в разы):
//   pothos_ready — «уйдут в архив сейчас» из «Обзора» pothos: accepted,
//     у которых SHIP_BLOCK_REASON_SQL = 'ok' (канон overview-board.ts);
//   eyeq_ready   — «Готово» из воронки «Обзора» eyeq: qa-принятое,
//     неотгруженное, со ссылкой там, где ячейка её требует, обрезанное
//     остатком ёмкости ячейки (канон handlers_manager.ts, handleManagerFunnel).
// Две правые — деньги: остаток кредитов OpenRouter и расход GCP за сегодня.
// null в любом поле = источник не ответил; виджет рисует «—», а не ноль.
import { z } from 'zod';

export const OpsWidgetMoneyResSchema = z.object({
  generated_at: z.string(),
  pothos_ready: z.number().nullable(),
  eyeq_ready: z.number().nullable(),
  // total_credits − total_usage у OpenRouter (то, что реально осталось);
  // limit_remaining — месячный лимит ключа, справочно вторым числом.
  openrouter: z.object({
    balance: z.number().nullable(),
    limit_remaining: z.number().nullable(),
  }),
  // Расход GCP за сегодня. Источника, кроме экспорта биллинга в BigQuery,
  // у Google нет: Cloud Billing API отдаёт прайс-лист, бюджеты — месяц.
  // unavailable говорит, ПОЧЕМУ пусто, чтобы виджет не врал нулём.
  gcp: z.object({
    today_usd: z.number().nullable(),
    // дата (YYYY-MM-DD) в часовом поясе биллинга, за которую посчитано
    day: z.string().nullable(),
    unavailable: z.string().nullable(),
  }),
});
export type OpsWidgetMoneyRes = z.infer<typeof OpsWidgetMoneyResSchema>;
